import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const THEMEUPDATE_TOUR_STORAGE_KEY = "se_admin_themeupdate_tour_seen_v1";

export const THEMEUPDATE_TOUR_STEPS = [
  {
    id: "tabs",
    target: "tour-gc-tabs",
    title: "Game Content",
    body: "Switch between the game page background images, the question list and the participant list.",
  },
  {
    id: "content",
    target: "tour-gc-content",
    title: "Images, Questions & Participants",
    body: "Upload desktop and mobile game page images, manage Truth and Dare questions, and add 4 to 10 participants for the spin-the-bottle game. Questions and participants can be added one at a time or imported from CSV.",
  },
];

export default function ThemeUpdateFeatureTour({ open, onClose }) {
  return <AdminFeatureTour open={open} onClose={onClose} steps={THEMEUPDATE_TOUR_STEPS} />;
}

export function markThemeUpdateTourSeen() {
  markTourSeen(THEMEUPDATE_TOUR_STORAGE_KEY);
}

export function shouldAutoStartThemeUpdateTour() {
  return shouldAutoStartTour(THEMEUPDATE_TOUR_STORAGE_KEY);
}
